class TabList extends HTMLElement {
  constructor() {
    super();
    this.tabFocus = 0;
    this.changeTabs = this.changeTabs.bind(this);
  }

  connectedCallback() {
    this.tabList = this.querySelector('[role="tablist"]');
    this.tabs = this.tabList.querySelectorAll(':scope > [role="tab"]');
    if (!this.tabList || this.tabs.length === 0) return;

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', this.changeTabs);
    });

    this.tabList.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
        this.tabs[this.tabFocus].setAttribute('tabindex', -1);
        if (e.key === 'ArrowRight') {
          this.tabFocus++;
          if (this.tabFocus >= this.tabs.length) {
            this.tabFocus = 0;
          }
        } else if (e.key === 'ArrowLeft') {
          this.tabFocus--;
          if (this.tabFocus < 0) {
            this.tabFocus = this.tabs.length - 1;
          }
        }

        this.tabs[this.tabFocus].setAttribute('tabindex', 0);
        this.tabs[this.tabFocus].focus();
      }
    });
  }

  changeTabs(e) {
    const targetTab = e.target;
    const tabList = targetTab.parentNode;
    const tabGroup = tabList.parentNode;

    tabList
      .querySelectorAll(':scope > [aria-selected="true"]')
      .forEach((t) => t.setAttribute('aria-selected', false));

    targetTab.setAttribute('aria-selected', true);

    tabGroup.querySelectorAll(':scope > [role="tabpanel"]').forEach((p) => {
      p.setAttribute('hidden', true);
      p.setAttribute('aria-hidden', 'true');
    });
    const targetPanel = tabGroup.querySelector(`#${targetTab.getAttribute('aria-controls')}`);
    targetPanel.removeAttribute('hidden');
    targetPanel.setAttribute('aria-hidden', 'false');
  }
}

customElements.define('tab-list', TabList);
